import { render, staticRenderFns } from "./skillModule.vue?vue&type=template&id=05caf5e4&scoped=true"
import script from "./skillModule.vue?vue&type=script&lang=js"
export * from "./skillModule.vue?vue&type=script&lang=js"
import style0 from "./skillModule.vue?vue&type=style&index=0&id=05caf5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05caf5e4",
  null
  
)

export default component.exports